import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1fec61fc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "@/scss/common.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./index.scss?vue&type=style&index=1&id=1fec61fc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fec61fc",
  null
  
)

export default component.exports